import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';

import { AuthorizationService } from '@shared/authorization.service';
import { FitConfigProviderService } from '@shared/fit-config-provider.service';

@Injectable({ providedIn: 'root' })
export class OutgoingWebhooksEnabledGuard {
    constructor(
        private fitConfig: FitConfigProviderService,
        private router: Router,
        private auth: AuthorizationService
    ) {}

    public canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return new Promise((resolve) => {
            this.auth.user.subscribe((user) => {
                if (!user) {
                    return resolve(true);
                }

                if (this.fitConfig.enableOutgoingWebhooks) {
                    return resolve(true);
                }

                this.router.navigateByUrl('/');
                return resolve(false);
            });
        });
    }
}

